import * as React from 'react';

import { getBuilderOnlineStatusText } from './utils';
import { getBuilderChatEnabled } from '../../selectors/builderChat';
import { useSelector } from 'react-redux';
import { getFirstBuilder } from '../../selectors/newbuilding';
import { OnlineStatus } from '../../components/OnlineStatus';

export const OnlineStatusContainer: React.FC = () => {
  const isChatsEnabled = useSelector(getBuilderChatEnabled);
  const builder = useSelector(getFirstBuilder);

  if (isChatsEnabled) {
    const isOnline = Boolean(builder?.chat?.isOnline);
    const text = getBuilderOnlineStatusText(isOnline);

    return <OnlineStatus isOnline={isOnline} text={text} />;
  }

  return null;
};
